module.exports = ".title {\n  font-size: 17px;\n}\n.success {\n  text-align: center;\n}\n.success .email {\n  text-align: center;\n  font-weight: bold;\n  margin-top: 10px;\n}\n.success div:first-of-type {\n  height: 80px;\n  width: 80px;\n  margin: auto;\n  border: 3px solid #fff;\n  border-radius: 43px;\n}\n.success div:first-of-type img {\n  width: 50px;\n  margin-top: 22px;\n}\n.success div:first-of-type i {\n  margin-top: 12px;\n  font-size: 45px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/lostpassword/lostpassword.component.less
// module id = 539
// module chunks = 0